import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  Typography
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearSupportRequestStatus,
  submitSupportRequest,
  supportSubmittedSelector,
  supportSubmittingSelector
} from '../../redux/features/support/supportSlice';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(4)
  },
  card: {
    borderRadius: theme.spacing(2)
  },
  intro: {
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(3)
  },
  sectionLabel: {
    fontWeight: 600,
    marginBottom: theme.spacing(1)
  },
  field: {
    marginBottom: theme.spacing(2)
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(2)
  }
}));

const Support = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const submitting = useSelector(supportSubmittingSelector);
  const submitted = useSelector(supportSubmittedSelector);

  const [type, setType] = useState('issue');
  const [subject, setSubject] = useState('');
  const [description, setDescription] = useState('');

  useEffect(() => {
    if (submitted) {
      setType('issue');
      setSubject('');
      setDescription('');
      dispatch(clearSupportRequestStatus());
    }
  }, [dispatch, submitted]);

  const isValid = subject.trim().length > 0 && description.trim().length > 0;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (!isValid || submitting) return;

    dispatch(
      submitSupportRequest({
        type,
        subject: subject.trim(),
        description: description.trim()
      })
    );
  };

  return (
    <Box className={classes.root}>
      <Card className={classes.card}>
        <CardHeader title="Report an Issue or Suggestion" />
        <CardContent>
          <Typography className={classes.intro}>
            Tell us what is not working or share an idea to improve the
            platform. We review every submission.
          </Typography>

          <form onSubmit={handleSubmit}>
            <Box className={classes.field}>
              <Typography className={classes.sectionLabel}>Type</Typography>
              <FormControl component="fieldset">
                <RadioGroup
                  row
                  value={type}
                  onChange={(event) => setType(event.target.value)}>
                  <FormControlLabel
                    value="issue"
                    control={<Radio color="primary" />}
                    label="Issue"
                  />
                  <FormControlLabel
                    value="suggestion"
                    control={<Radio color="primary" />}
                    label="Suggestion"
                  />
                </RadioGroup>
              </FormControl>
            </Box>

            <TextField
              className={classes.field}
              label="Subject"
              fullWidth
              variant="outlined"
              value={subject}
              onChange={(event) => setSubject(event.target.value)}
              placeholder="Short summary of your issue or idea"
              required
            />

            <TextField
              className={classes.field}
              label="Description"
              fullWidth
              variant="outlined"
              multiline
              minRows={5}
              value={description}
              onChange={(event) => setDescription(event.target.value)}
              placeholder="Add as much detail as you can so we can help."
              required
            />

            <Box mt={3} className={classes.actions}>
              <Button
                type="submit"
                color="primary"
                variant="contained"
                disabled={!isValid || submitting}>
                {submitting ? 'Submitting…' : 'Send Request'}
              </Button>
            </Box>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
};

export default Support;
